angular.module("vgresiduos").controller("VertownNotificationEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/comunicados-vertown/${$stateParams.id}`);
		};
	}
]);
